/**=========================================================
 * Module: emails.js
 * Emails Controller
 =========================================================*/

App.controller('EmailsController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', '$filter',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $filter) {
    "use strict";

    $scope.type = 'emaillog';
    $scope.filter = $state.params.filter;

    var filterA = $scope.filter.split('&')
    var filterObj = {}
    for(var i=0; i<filterA.length; i++){
        var f = filterA[i].split('=');
        filterObj[f[0]] = f[1]
    }

    $scope.data = [];

    $scope.page = {
        title: 'labels.VIEWEMAILS',
        subTitle: ''
    };

    $scope.fromPostmark = false;
    if($scope.filter && $scope.filter.indexOf('=')<0){
        $scope.fromPostmark = true;
    }

    $scope.table = {
        type: 'emaillog',
        includedFields: ['toAccount','results'],
        title: '',
        fields: [
            {
            	available: true,
                name: 'sentOn',
                type: 'date',
                format: 'YYYY-MM-DD HH:mm:ss'
            },{
            	available: !$scope.fromPostmark,
                name: 'sent',
                type: 'boolean'
            },{
            	available: true,
                name: 'to',
                type: 'string',
                hasLink: true
            },{
            	available: true,
                name: 'template',
                type: 'string'
            },{
            	available: !$scope.fromPostmark,
                name: 'project',
                type: 'string',
                hasLink: true,
                link: {
                    action: 'view',
                    type: 'project',
                    filter: 'projectId'
                }
            },{
            	available: $scope.fromPostmark,
                name: 'body',
                label: 'subject',
                type: 'string'
            },{
                available: $scope.fromPostmark,
                name: 'status',
                type: 'string'
            },{
                available: !$scope.fromPostmark,
                name: 'data',
                type: 'html'
            }
        ],
        link: {
            action: 'view',
            type: 'user',
            filter: 'toAccount'
        }
    }

    $scope.filterForm = {
        title: '',
        status: '',
        type: 'emails',
        model: {
            sent: filterObj.sent,
            date: filterObj.date ? new Date(parseInt(filterObj.date.substring(0,4)), parseInt(filterObj.date.substring(4,6))-1, parseInt(filterObj.date.substring(6,8))) : null
        },
        fields: [
            {
                available: true,
                type: 'switch',
                name: 'sent',
                options: [
                    { value: 'true', label: 'labels.YES'},
                    { value: 'false', label: 'labels.NO'}
                ]
            },{
                available: true,
                type: 'date',
                name: 'date',
                label: 'fields.SENTON',
                minDate: new Date(2020,5,26),
            },
            {
                available: true,
                type: 'submit',
                name: 'empty',
                label: 'labels.FILTER'
            }
        ],
        submit: function(){
            var filter = '';
            if(this.model.sent) filter+='sent='+this.model.sent
            if(this.model.date) {
                if(filter) filter+='&'
                filter+='date='+$filter('display')(this.model.date, { type: 'date', format: 'YYYYMMDD' })
            }
            $state.go('app.entity', { action: 'list', type: 'emails', filter: filter}, { reload: true })
        }
    }

    $scope.table.baseFilter = function(){
        var f = $scope.filter;
        f = f.replace('date=','senton=')
        if($scope.fromPostmark){
            if(f.indexOf('@')>=0){
                f = '_postmark=true&_recipient=' + f;
            } else {
                f = '_postmark=true&_projectCode=' + f;
            }
        }
        return f
    }()

    $scope.table.loadCallback = function(scope){
        for(var i=0; i<scope.data.length; i++){
            if($scope.fromPostmark){
                for(var j=0; j<scope.data[i].results.length; j++){
                    var e = scope.data[i].results[j];
                    if(!scope.data[i].status){
                        scope.data[i].status = e.Type;
                    }
                    if(e.Type==='Delivered' && scope.data[i].status!='Opened'){ scope.data[i].status = e.Type; }
                    if(e.Type==='Opened'){ scope.data[i].status = e.Type; }
                    if(e.Type==='Bounced'){ scope.data[i].status = e.Type; }
                }
            }
            if(scope.data[i].data){
                var data = scope.data[i].data;
                var pre = '';
                for(var k in Object.keys(data)){
                    var key = Object.keys(data)[k];
                    if(data[key]){
                        pre += '<strong>' + key + ':</strong> ' + data[key].replace(/</g, '&lt;').replace(/>/g, '&gt;') + '\n'
                    }
                }
                scope.data[i].data = '<pre class="pre-in-table">'+pre+'</pre>'
                scope.data[i].project = data['project.code']
                scope.data[i].projectId = data['project.id']
            }
        }
    }



  }
  ]);
